
import { menudb } from "./menudb.js";
import fondoMaderaGrande from "../../imagenes/fondoMaderaGrande.webp";
import fondoMaderaPequeno from "../../imagenes/fondoMaderaPequeno.webp";
const bdSopas = [...menudb[0].sopas];

function Sopas() {
  return (
    <div id="sopas">

      {/* SECCION 1 DE SOPAS */}
      <div
        id="sopa-1"
        className="relative min-h-screen bg-cover bg-center bg-no-repeat flex flex-col items-center justify-center text-white px-3 gap-10"
      >
        <p className="text-2xl ">SOPAS RAMEN</p>
        <div className="flex items-center justify-center gap-3 xl:mr-60">
          <img
            width={160}
            height={160}
            alt="Ramen Clásico"
            loading="lazy"
            src={require(`../../imagenes/sopas/${bdSopas[0].image}-160-160.webp`)}
          />
          <div className="max-w-60 flex flex-col items-center justify-center gap-4">
            <h4 className="text-xl bg-black/50 px-10 py-1">{bdSopas[0].name}</h4>
            <hr className="w-20"></hr>
            <p>{bdSopas[0].description}</p>
            <div className="flex items-center h-[14px]">
              <hr className="w-20 ml-6"></hr>
              <p className="ml-6">s/. {bdSopas[0].price}</p>
            </div>
          </div>
        </div>
         <div className="flex flex-row-reverse items-center justify-center gap-3 xl:ml-60">
          <img
            width={160}
            height={160}
            alt="Ramen Picante"
            loading="lazy"
            src={require(`../../imagenes/sopas/${bdSopas[1].image}-160-160.webp`)}
          />
          <div className="max-w-60 flex flex-col items-center justify-center gap-4">
            <h4 className="text-xl bg-black/50 px-8 py-1">{bdSopas[1].name}</h4>
            <hr className="w-20"></hr>
            <p>{bdSopas[1].description}</p>
            <div className="flex items-center h-[14px]">
              <hr className="w-20 ml-6"></hr>
              <p className="ml-6">s/. {bdSopas[1].price}</p>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 right-0 w-full grid place-items-center h-[40px] bg-black/30 text-white">
          KoreanMania - Huancayo
        </div>
      </div>

      {/*  SECCION 2 DE SOPAS */}
      <div
        id="sopa-2"
        className="relative min-h-screen bg-cover bg-center bg-no-repeat flex flex-col items-center justify-center text-white px-3 gap-10"
      >
        <div className="flex items-center justify-center gap-3 xl:mr-60">
          <img
            width={160}
            height={160}
            alt="Ramen Cheese"
            loading="lazy"
            src={require(`../../imagenes/sopas/${bdSopas[2].image}-160-160.webp`)}
          />
          <div className="max-w-60 flex flex-col items-center justify-center gap-4">
            <h4 className="text-xl bg-black/50 px-8 py-1">{bdSopas[2].name}</h4>
            <hr className="w-20"></hr>
            <p>{bdSopas[2].description}</p>
            <div className="flex items-center h-[14px]">
              <hr className="w-20 ml-6"></hr>
              <p className="ml-6">s/. {bdSopas[2].price}</p>
            </div>
          </div>
        </div>
         <div className="flex flex-row-reverse items-center justify-center gap-3 xl:ml-60">
          <img
            width={160}
            height={160}
            alt="Ramen Marisco"
            loading="lazy"
            src={require(`../../imagenes/sopas/${bdSopas[3].image}-160-160.webp`)}
          />
          <div className="max-w-60 flex flex-col items-center justify-center gap-4">
            <h4 className="text-xl bg-black/50 px-8 py-1">{bdSopas[3].name}</h4>
            <hr className="w-20"></hr>
            <p>{bdSopas[1].description}</p>
            <div className="flex items-center h-[14px]">
              <hr className="w-20 ml-6"></hr>
              <p className="ml-6">s/. {bdSopas[3].price}</p>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 right-0 w-full grid place-items-center h-[40px] bg-black/30 text-white">
          KoreanMania - Disfruta
        </div>
      </div>

      {/* SECCION 3 DE SOPAS */}
      <div
        id="sopa-3"
        className="relative min-h-screen bg-cover bg-center bg-no-repeat flex flex-col items-center justify-center text-white px-3 gap-10"
      >
        <div className="flex items-center justify-center gap-3 xl:mr-60">
          <img
            width={160}
            height={160}
            alt="Tonkutsu ramen"
            loading="lazy"
            src={require(`../../imagenes/sopas/${bdSopas[4].image}-160-160.webp`)}
          />
          <div className="max-w-60 flex flex-col items-center justify-center gap-4">
            <h4 className="text-xl bg-black/50 px-8 py-1">{bdSopas[4].name}</h4>
            <hr className="w-20"></hr>
            <p>{bdSopas[0].description}</p>
            <div className="flex items-center h-[14px]">
              <hr className="w-20 ml-6"></hr>
              <p className="ml-6">s/. {bdSopas[4].price}</p>
            </div>
          </div>
        </div>
         <div className="flex flex-row-reverse items-center justify-center gap-3 xl:ml-60">
          <img
            width={160}
            height={160}
            alt="Miso Ramen"
            loading="lazy"
            src={require(`../../imagenes/sopas/${bdSopas[5].image}-160-160.webp`)}
          />
          <div className="max-w-60 flex flex-col items-center justify-center gap-4">
            <h4 className="text-xl bg-black/50 px-8 py-1">{bdSopas[5].name}</h4>
            <hr className="w-20"></hr>
            <p>{bdSopas[1].description}</p>
            <div className="flex items-center h-[14px]">
              <hr className="w-20 ml-6"></hr>
              <p className="ml-6">s/. {bdSopas[5].price}</p>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 right-0 w-full grid place-items-center h-[40px] bg-black/30 text-white">
          KoreanMania - Vive
        </div>
      </div>

      <style>
        {`
    @media (max-width: 768px){
      #sopa-1, #sopa-2, #sopa-3{
        background-image: url(${fondoMaderaPequeno});
      }  
    }
    @media (min-width: 768px) {
      #sopa-1, #sopa-2, #sopa-3 {
        background-image: url(${fondoMaderaGrande});
      }
    }
  `}
      </style>
    </div>
  );
}

export default Sopas;
